import type { FC } from "react";

import WhitelistCategoryView from "../components/WhitelistCategoryView";

const PriceMonitorWhitelistRoute: FC = () => {
  return (
    <WhitelistCategoryView category="price-monitor" title="Price monitor" />
  );
};

export default PriceMonitorWhitelistRoute;
